import { useState } from 'react';
import NavItem from 'components/app/topbar/navigation/NavItem';
import DropdownMenu from 'react-dd-menu';
import { MenuItem } from 'components/menu/MenuItems';
import { RouteUrls } from 'routes/RouteConstants';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasReportTemplateEnabled } from 'state/user/selectors';
import { roles as userRoles } from 'config/constants';
import { AppFeaturePermissions, usePermissions } from 'contexts';

const menuItemStyle = { width: '180px' };

const ReportsMenu = ({ isAdmin, isReportManager, isMyReports }) => {
    const permissions = usePermissions();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const activeState = isReportManager || isMyReports;

    const renderButton = () => {
        return (
            <NavItem
                title={'Reports'}
                active={activeState}
                icon=""
                onClick={toggleMenu}
                hideTooltip={true}
                dropdown
                style={{ paddingLeft: '23px' }}
            >
                <i
                    className="fa-solid fa-table"
                    size="lg"
                    style={{
                        position: 'absolute',
                        left: '5px',
                    }}
                />
                <i
                    className="fa-solid fa-caret-down"
                    size="lg"
                    style={{
                        paddingLeft: '6px',
                        fontSize: '16px',
                    }}
                />
            </NavItem>
        );
    };

    const showMyReports = permissions?.featurePermissions?.includes(
        AppFeaturePermissions.MyReports
    );

    if (!showMyReports && !isAdmin) {
        return null;
    }

    return (
        <DropdownMenu
            animate={false}
            align="left"
            isOpen={isMenuOpen}
            toggle={renderButton()}
            close={toggleMenu}
        >
            {showMyReports && (
                <MenuItem
                    active={isMyReports}
                    style={menuItemStyle}
                    to={RouteUrls.MY_REPORT_TEMPLATE}
                >
                    <span>My Reports</span>
                </MenuItem>
            )}
            {isAdmin && (
                <MenuItem
                    active={isReportManager}
                    style={menuItemStyle}
                    to={RouteUrls.REPORT_MANAGER}
                >
                    <span>Report Manager</span>
                </MenuItem>
            )}
        </DropdownMenu>
    );
};

export default withRouter(
    connect((state) => {
        const {
            routing: {
                locationBeforeTransitions: { pathname },
            },
        } = state;
        const { roles } = state.user;
        const isAdmin = roles.includes(userRoles.CLIENT_ADMIN);

        const isReportManager = pathname.includes(
            RouteUrls.PLANNING_CAPITAL_TRACKER
        );
        const isMyReports = pathname.includes(
            RouteUrls.PLANNING_PRIORITIES_AND_OBJECTIVES
        );

        return {
            isReportManager,
            isMyReports,
            isAdmin,
            reportsEnabled: hasReportTemplateEnabled(state),
        };
    })(ReportsMenu)
);
